import { useTranslation } from 'react-i18next'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { useMutation, gql } from '@apollo/client'

import { toast } from 'components/global/CUK/Toast/Toast'
import ActionModal from 'components/Modal/ActionModal'

export const OPERATION_REMOVE_ADVERTISEMENT = gql`
    mutation RemoveAdvertisement($id: ID!) {
        removePortalAdvertisement(id: $id) {
            status
        }
    }
`


const RemoveAdvertisement = () => {
  const { id } = useParams()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [removeAdvertisement, { loading }] = useMutation(OPERATION_REMOVE_ADVERTISEMENT, )
  const [, setSearchParams] = useSearchParams()
  const handleClose = () => {
    navigate({ pathname: '/advertisements', state: {id} })
  }

  const handleConfirmation = async () => {
    try {
      await removeAdvertisement({
        variables: { id },
        update: cache => {
          cache.evict({id: `PortalAdvertisement:${id}`})
        }
      })
      toast.success(t('advertisements.edition.toaster.deletion_success'))
      setSearchParams({ refresh: 100 })
    } catch {
      toast.error(t('advertisements.edition.toaster.deletion_error'))
    } finally {
      handleClose()
    }
  }

  return (
    <ActionModal
      cancelLabel={t('advertisements.edition.buttons.cancel')}
      confirmLabel={t('advertisements.edition.buttons.delete')}
      description={t('advertisements.edition.content.delete_confirm_content')}
      icon={<i className="fa-regular fa-trash" />}
      loading={loading}
      onClose={handleClose}
      onConfirm={handleConfirmation}
      title={t('advertisements.edition.content.warn')}
    />
  )
}

export default RemoveAdvertisement
